import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import axios from 'axios'
import VueAnalytics from 'vue-analytics'
import nProgressBar from 'nprogress'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar';

// router setup
import routes from './routes/routes'


// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'
import auth from './auth';

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)

Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
locale.use(lang)

Vue.use(VueNotify, {
  icon: 'nc-icon nc-bell-55',
  horizontalAlign: 'left',
  verticalAlign: 'bottom',
  type: 'info'

})

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
});

// Add a request interceptor
axiosInstance.interceptors.request.use(function (config) {
  nProgressBar.start()
  return config;
}, function (error) {
  nProgressBar.done()
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(function (response) {
  nProgressBar.done()
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if(error.response.data.message == 'Unauthenticated.') {
    auth.logout ()
    router.push("/login")
  }
  nProgressBar.done()
  nProgressBar.remove()
  return Promise.reject(error);
});

Vue.prototype.$http = axiosInstance;


if(auth.getToken()){
  auth.setHeaderAuthorization(Vue.prototype.$http)

  //setup to logout user after 2 minutes of no click
  var lastClickEvent
  function inactivityLogout(){
    clearTimeout(lastClickEvent)
    lastClickEvent = setTimeout(() => {
      router.push('/logout?src=inactivity')
    }, 5 * 60 * 1000)
  }
  inactivityLogout()
  document.addEventListener('click', inactivityLogout())
}

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

initProgress(router);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})
